import { useEffect, useState } from "react";
import { GuidePostService } from "@oldDashboard/legacyServices/guide-posts/guidePostService";
import { MotivationPrinciple } from "@oldDashboard/legacyModels/motivationPrinciple.model";
import { ChartName } from "@oldDashboard/legacyModels/chart.model";
import { setMotivationPrinciplesAction } from "@oldDashboard/legacyActions/dashboardClient";

interface UseRunningIdeasProps {affiliateSelected: any, launchSelected: String, timePeriodSelected: String, startDate: String, endDate: String, searching: boolean }
const useMotivationPrinciples = (props: UseRunningIdeasProps) => {
    const { affiliateSelected, launchSelected,timePeriodSelected, startDate, endDate, searching } = props;
    const [chartData, setChartData] = useState<ChartName>();
    const [isLoading, setIsLoading] = useState(false);

    useEffect( () => {
        fetchMotivationPrinciples();
    }, [searching, launchSelected]);

    const buildChartData = (data: MotivationPrinciple[]): ChartName => {
        const sum = data.map(item => Number(item.y)).reduce((accumulator, current) => accumulator + current);
        return {
            series: [{
                data:data.map(item=>Number((Number(item.y) / sum * 100).toFixed(0))),
                name:""
            }],
            options: {
                chart: {
                    type: 'bar',
                    toolbar:{
                        show: false
                    },
                    height: 250,
                    events: {
                        mounted: (chart:any) => {
                            chart.windowResizeHandler();
                        }
                    },
                },
                plotOptions: {
                    bar: {
                        barHeight: '100%',
                        distributed: true,
                        horizontal: true,
                        dataLabels: {
                            position: 'bottom'
                        },
                    }
                },
                colors: ["#845adf", "#23b7e5", "#f5b849", "#e6533c", "#74db50", "#ff7373", "#5b67c7", "#a65e9a",
                    "#26bf94", "#b00b69"
                ],
                grid: {
                    borderColor: '#f2f5f7',
                },
                dataLabels: {
                    enabled: false,
                    textAnchor: 'start',
                    style: {
                        colors: ['#444']
                    },
                    offsetX: 0,
                    dropShadow: {
                        enabled: false
                    }
                },
                stroke: {
                    width: 1,
                    colors: ['#fff']
                },
                xaxis: {
                    categories: data.map(item=>item.description),
                    labels: {
                        show: false,
                        style: {
                            colors: "#8c9097",
                            fontSize: '11px',
                            fontWeight: 600,
                            cssClass: 'apexcharts-xaxis-label',
                        },
                    }
                },
                yaxis: {
                    labels: {
                        show: false
                    }
                },
                legend: {
                    show: true,
                    customLegendItems: data.map(item=>item.name),
                },
                tooltip: {
                    theme: 'dark',
                    fixed: {
                        enabled: true,
                        position: 'bottomLeft',
                    },
                    custom: function(items: any) {
                        return '<div class="arrow_box px-2 py-2">' +
                          '<span><b>'+ items.w.config.legend.customLegendItems[items.dataPointIndex] + '</b></span>' +
                          '<br>'+
                          '<span>'+ items.w.globals.labels[items.dataPointIndex] + '</span>' +
                          '<br>'+
                          '<span '+"style='color:"+items.ctx.w.config.colors[items.dataPointIndex]+";'"+'>&#9673;</span>'+
                          '<span> '+items.w.globals.stackedSeriesTotals[items.dataPointIndex]+'%</span>' +
                          '</div>'
                      }
                }
            }
        };
    }

    const fetchMotivationPrinciples = async() => {
        setIsLoading(true);
        try {
            const service = new GuidePostService();
            const response = await service.getMotivationPrinciples(affiliateSelected, launchSelected,timePeriodSelected, startDate, endDate);
            if(response) {
                setMotivationPrinciplesAction(response);
                const graphData = buildChartData(response);
                setChartData(graphData);
            }
        } catch (error: any) {
            console.log("ERROR ", error)
        } finally {
            setIsLoading(false);
        }

    }
    return { isLoading, chartData, fetchMotivationPrinciples }
}

export default useMotivationPrinciples
